<div class="mode-wrapper" id="mode-wrapper" #modeWrapper>
  <router-outlet></router-outlet>
</div>
